module.exports = __webpack_public_path__ + "img/74_23.a983f700.png";